import { render, staticRenderFns } from "./amadeusaktarimftp.vue?vue&type=template&id=12fb321f"
import script from "./amadeusaktarimftp.vue?vue&type=script&lang=js"
export * from "./amadeusaktarimftp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports